var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"270bc55241d2a506ad9bd68cac2b324d92dc296c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["webflow-js@sharesy"]={id:"270bc55241d2a506ad9bd68cac2b324d92dc296c"};
      